const getRemoteIframe = state => state.remoteIframe;

export default {
  getRemoteIframe
};
